export const formatCaseStatus = (status) => {
  if (!status) return '';

  const labels = {
    INITIAL_INQUIRY_LEAD_CAPTURE: 'Initial Inquiry & Lead Capture',
    NEW: 'New',
    IN_PROGRESS: 'In Progress',
    CREATED: 'Created',
    RESEARCH_IN_PROGRESS: 'Research In Progress',
    RESEARCH_COMPLETED: 'Research Completed',
    VERIFICATION_IN_PROGRESS: 'Verification In Progress',
    VERIFICATION_COMPLETED: 'Verification Completed',
    DRAFT_IN_PROGRESS: 'Draft In Progress',
    DRAFT_COMPLETED: 'Draft Completed',
    FILED: 'Filed',
    CLOSED: 'Closed',
    ARCHIVED: 'Archived',
  };

  return labels[status] || String(status).replaceAll('_', ' ');
};
